// src/utils/api.js
import axios from 'axios';
import { inject } from 'vue';

// Create Axios instance without baseURL initially
const api = axios.create();

let isLoading;

export function setupAxiosInterceptors() {  // Accept app instance as parameter
  // Get the global BASE_API_URL from app config
  const BASE_API_URL =`https://ver2.viamenus.com`;
  
  // Set baseURL for all requests
  api.defaults.baseURL = BASE_API_URL ? `${BASE_API_URL}/api` : '/api';

  // Get the loading state
  isLoading = inject('isLoading');

  // Request interceptor
  api.interceptors.request.use((config) => {
    if (isLoading) isLoading.value = true;
    return config;
  });

  // Response interceptor
  api.interceptors.response.use(
    (response) => {
      if (isLoading) isLoading.value = false;
      return response;
    },
    (error) => {
      if (isLoading) isLoading.value = false;
      return Promise.reject(error);
    }
  );
}

export default api;